import { FC } from 'react'
import VariableLeadField, {
  VariableLeadFieldSettings,
} from '../../../VariableLeadField/VariableLeadField'
import { Field } from '@/api/types/crm.types'
import classes from './index.module.css'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'

interface LeadFieldProps {
  field: Field
  value?: string
  onChange: (val: string) => void
  fieldSettings?: VariableLeadFieldSettings
  disabled?: boolean
}

const LeadField: FC<LeadFieldProps> = ({
  field,
  value,
  onChange,
  fieldSettings,
  disabled,
}) => {
  return (
    <TooltipWrapper
      key={field.id}
      title={field.name}
      overlayClassName={classes.tooltipOverlay}
    >
      <div
        style={
          disabled
            ? {
                pointerEvents: 'none',
                userSelect: 'none',
              }
            : {}
        }
      >
        <VariableLeadField
          type={field.type}
          fieldProps={{
            field,
            id: field.unique_name,
            name: field.unique_name,
            value: value ?? '',
            onChange: (e) => {
              if (disabled) return
              onChange(typeof e === 'string' ? e : e.target.value)
            },
            placeholder: field.name,
          }}
          fieldSettings={fieldSettings}
        />
      </div>
    </TooltipWrapper>
  )
}

export default LeadField
